import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import FleetManagementApiService from './FleetManagementApiService';
import { setConsolidatedFleetPo, setFleetPo } from 'Store/OrderManagement/FleetProcessing/FleetProcessingAction';

import {
  GET_FLEET_PO, CREATE_CONSOLIDATED_PO
} from "../../Store/OrderManagement/FleetProcessing/FleetProcessingType";
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getFleetPo(req: any): any {
  try {
    yield put(globalLoaderText("Creating PO...."));
    let payloadData : IPayload= {
      apiType : apiType.FleetManagement,
      endpoint : `fleet/purchaseorder`,
      apiMethod :  apiMethod.POST,
      payload : req.payload
      
     }
    const response = yield call(
        FleetManagementApiService.post,API_URL.PostWebApp,payloadData
     
      
    );
    if (response) {
      yield put(setFleetPo(response));
    }
    yield put(globalLoaderText(""));
  } catch (error: any) {
    yield put(setFleetPo(error));
    yield put(globalLoaderText(""));
  }
}

function* getConsolidatedFleetPo(req: any): any {
  try {
    yield put(globalLoaderText("Creating PO...."));
    let payloadData : IPayload= {
      apiType : apiType.FleetManagement,
      endpoint : `fleet/consolidated/purchaseorder`,
      apiMethod :  apiMethod.POST,
      payload : req.payload
      
     }
    const response = yield call(
        FleetManagementApiService.post,API_URL.PostWebApp,payloadData
     
      
    );
    if (response) {
      yield put(setConsolidatedFleetPo(response));
    }
    yield put(globalLoaderText(""));
  } catch (error: any) {
    yield put(setConsolidatedFleetPo({ errorMessages: ["Something went wrong..! Please try again later"]}));
    yield put(globalLoaderText(""));
  }
}

function* pendingOrderSagaWatcher() {
  yield takeEvery(GET_FLEET_PO, getFleetPo);
  yield takeEvery(CREATE_CONSOLIDATED_PO, getConsolidatedFleetPo);
}

export default function* combinedSaga() {
  yield all([pendingOrderSagaWatcher()]);
}
